import { CheckoutState } from './checkoutState';

export const steps = ['auth', 'shipping', 'payment'] as const;

export type Step = typeof steps[number];

export const getStepFromRoute = (route: string) => route.slice(1).split('/').shift() as Step;

export const getInitialRoute = (checkoutState: CheckoutState) => {
  if (!checkoutState.customer) {
    return '/auth';
  } else if (!checkoutState.orderState.addresses?.shipping) {
    return '/shipping';
  } else {
    return '/payment';
  }
};
